import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'

import Textroll from './textroll'


class Contact extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.speed = 2
    this.isPlaying = false
    this.isVisible = false
    this.isAnimating = false

    this.ref = {
      track: null,
      elm: null,
      bg: null,
      close: null,
      details: []
    }

  }

  mount() {

      this.resizeQue = this.resize.bind(this)
      stage.on("stage:resize", this.resizeQue);
      this.renderQue = this.render.bind(this)
      stage.on("stage:scroll", this.renderQue);
      this.resize(stage)
      //console.log("Mount Text!");
      this.isPlaying = false
      this.roll = new Textroll(this.element, this.ref)
      this.roll.mount()


      this.tl = gsap.timeline({onComplete: this.tlcomplete.bind(this)});
      this.tl.pause()
      this.tl.set(this.element, {y: '0%', force3D: true, ease: 'expo.out'}, 0)
      this.tl.to(this.ref.bg, 1, {y: '0%', force3D: true, ease: 'expo.out'}, 0)
      this.tl.to(this.ref.track, .75, { alpha: 1, force3D: true, ease: 'sine.in'}, .23)
      this.tl.to(this.ref.details, .3, { alpha: 1, stagger: -0.1, y: "0%" ,force3D: true, ease: 'expo.out'}, .43)
      //this.tl.to(this.ref.track, .75, {y: '0%', force3D: true}, .19)
    //  this.tl.to(this.ref.track, 1.2, {filter: 'blur(0px)', force3D: true, ease: 'sine.out'}, .19)

      this.tb = gsap.timeline({onComplete: this.tbcomplete.bind(this)});
      this.tb.pause()
      this.tb.set(this.element, {y: '-100%', force3D: true, ease: 'expo.out'}, 1.2)
      this.tb.to(this.ref.bg, 1.2, {y: '-100%', force3D: true, ease: 'expo.out'}, .2)
      this.tb.to(this.ref.track, .75, { alpha: 0, force3D: true, ease: 'sine.out'}, 0)
      this.tb.to(this.ref.details, .3, { alpha: 0, stagger: 0.1, y: "-100%" ,force3D: true, ease: 'expo.out'}, 0)
    //  this.tb.to(this.ref.track, .49, {y: '-10%', ease: 'sine.out'}, 0)
    //  this.tb.to(this.ref.track, .89, {filter: 'blur(11px)',  ease: 'sine.out'}, 0)

    $('.contact-trigger').on('click', (e)=>{
      e.preventDefault()
      this.showContact()
    })


    $(this.ref.close).on('click', (e)=>{
        e.preventDefault()
        this.showContact()
    })
  }

  tbcomplete(){
    this.isAnimating = false
    this.isVisible = false

    this.stop()
  }
  tlcomplete(){
    this.isAnimating = false
    this.isVisible = true

  }

  showContact(){

    //console.log(stage.h);

    if (!this.isVisible && !this.isAnimating){
      this.isAnimating = true
      this.tl.restart()
      this.play()
      $('body').addClass('has-contact')

    }
    else if (this.isVisible && !this.isAnimating){
      this.isAnimating = true
      this.tb.restart()
      $('body').removeClass('has-contact')
    }

  }

  resize(e){
    this.main = $('.wrapper').height();
    $('main').height(this.main + stage.h/2);
    this.render(e);
  }

  render(e){
    this.body.toggleClass('has-footer', e.scrolltop + e.h/2 >= this.main - e.h/5)
  }


  stop(){
    this.roll.stop()
    this.isPlaying = false
  }

  play(){
    this.roll.play()
    this.isPlaying = true
  }


  unmount() {
    stage.removeListener("stage:resize", this.resizeQue);
    stage.removeListener("stage:scroll", this.renderQue);
    this.roll.unmount()

  }


}

module.exports = Contact
